import { t } from 'i18next';

import { OpenClassCertificateType } from '../types/OpenClass';

export const certificateTypeLabel = (
  certificateType: OpenClassCertificateType,
): string => t(`views.OpenClasses.certificateTypeLabels.${certificateType}`);
